import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';

import { decodeHasAssistanceParams } from '../../../utils/security.utils';
import { logData } from '../../../utils/debug.util';
import { setProvider } from '../../../store/slices/generalSlice';
import { ContentLayout, FormLayout } from '../../../global-styles/layout';
import { INSURANCE_COMPANIES } from '../../../constants';
import WantToCallMe from '../../../components/want-to-call-me/WantToCallMe';
import ChatContact from '../../../components/chat-contact/ChatContact';
import AlxButton from '../../../components/alx-components/button';
import { images } from '../../../assets/images/images';
import { HasAssistanceStyles } from './has-assistance';

const HasAssistance = () => {
  const { t } = useTranslation(['common', 'hasAssistance']);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const { entityCode, isChatAllowed } = decodeHasAssistanceParams(params.reference || '') || {};

  const assistanceDate = new Date().toLocaleDateString();
  const intervention: string = params.intervention || '';
  const [contact, setContact] = useState<boolean>(false);
  const [chatSelected, setChatSelected] = useState<boolean>(false);
  const [wantToCallmeSelected, setWantToCallmeSelected] = useState<boolean>(false);

  useEffect(() => {
    dispatch(setProvider({ provider: entityCode }));
  }, [dispatch, entityCode]);

  const prepareURL = () => {
    logData('uri', `/${INSURANCE_COMPANIES[entityCode!]?.webParam}`);
    return `/${INSURANCE_COMPANIES[entityCode!]?.webParam}`;
  };

  return (
    <ContentLayout data-cy="has-assistance-page">
      {!chatSelected && !wantToCallmeSelected && (
        <HasAssistanceStyles>
          <div className="onboarding-top">
            <div className="invalid-text">{t('hasAssistance:text1', { assistanceDate })}</div>
            <div className="invalid-text">{t('hasAssistance:text2')}</div>
            <div className="invalid-text">{t('hasAssistance:text3')}</div>
            <div className="truck-img">
              <img src={images.cars} alt="" />
            </div>
          </div>
          <FormLayout>
            <AlxButton onClick={() => navigate(prepareURL())} data-cy="new-assistance-button">
              {t('hasAssistance:new-assistance-button')}
            </AlxButton>
            <AlxButton onClick={() => setContact(true)} data-cy="contact-button">
              {t('hasAssistance:contact-button')}
            </AlxButton>
          </FormLayout>
          {contact && (
            <FormLayout className="contact-block">
              {isChatAllowed && (
                <AlxButton
                  onClick={() => setChatSelected(true)}
                  data-cy="contact-chat-button"
                  disabled={!isChatAllowed}
                >
                  {t('hasAssistance:contact-chat-button')}
                </AlxButton>
              )}
              <AlxButton
                onClick={() => setWantToCallmeSelected(true)}
                data-cy="contact-call-button"
                disabled={!intervention}
              >
                {t('hasAssistance:contact-call-button')}
              </AlxButton>
            </FormLayout>
          )}
        </HasAssistanceStyles>
      )}
      {chatSelected && <ChatContact />}
      {wantToCallmeSelected && <WantToCallMe intervention={intervention} />}
    </ContentLayout>
  );
};

export default HasAssistance;
